export default __webpack_public_path__ + "cb0789199d7852f91272c537f2884aff.png";